<template>
  <div class="message" :class="typeName" :style="combinedStyles.container">
    <div class="icon">
      <img :src="icon" />
    </div>
    <div class="content">
      <div
        class="title"
        :style="combinedStyles.title"
        v-html="message.title"
      ></div>
      <div class="text" :style="combinedStyles.text" v-html="text"></div>
      <div class="date" :style="combinedStyles.date">
        {{ date }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import UploadImageIcon from '@/img/website-image.png'

export default {
  name: 'InboxMessagePreview',
  props: {
    message: Object,
    messageType: Number,
    messageStyle: Object,
    globalStyles: Object
  },

  computed: {
    typeName: function() {
      if (this.messageType === 1) {
        return 'card'
      } else {
        return 'alert'
      }
    },

    icon: function() {
      if (this.message.icon) {
        return this.message.icon
      } else {
        return UploadImageIcon
      }
    },

    text: function() {
      if (this.message.text) {
        return this.message.text
      } else {
        return this.message.alert
      }
    },

    date: function() {
      if (this.messageType !== 1) {
        return moment().format('L LT')
      }
    },

    messageStyles: function() {
      return {
        container: {
          backgroundColor: this.messageStyle.bg
        },
        title: {
          backgroundColor: this.messageStyle.title_bg
        }
      }
    },

    combinedStyles: function() {
      let styles = {}
      let globalStyles = this.globalStyles
      let messageStyles = this.messageStyles

      for (let localStyles of [globalStyles, messageStyles]) {
        for (let item of Object.keys(localStyles)) {
          if (styles[item] === undefined) {
            styles[item] = {}
          }
          for (let style of Object.keys(localStyles[item])) {
            if (localStyles[item][style]) {
              styles[item][style] = localStyles[item][style]
            }
          }
        }
      }

      return styles
    }
  }
}
</script>

<style scoped>
.message {
  border: 1px solid #bebebe;
  background: #ffffff;
  font-family: 'Trebuchet MS', 'Helvetica', sans-serif;
  cursor: default;
  position: relative;
  width: 300px;
}
.icon {
  display: block;
  line-height: 0;
}

.alert {
  display: flex;
  padding: 8px;
}
.alert .icon {
  margin-right: 8px;
  width: 48px;
}
.alert .icon img {
  width: 48px;
  height: 48px;
}
.alert .content {
  flex: 1;
  line-break: anywhere;
}
.alert .text {
  margin-top: 4px;
  margin-bottom: 4px;
}

.card .icon img {
  width: 100%;
}
.card .title {
  padding: 5px 7px;
}
.card .text,
.card .date {
  padding: 3px 7px;
}
.card .content {
  line-break: anywhere;
}

.title,
.title >>> p {
  font-size: 12px;
  line-height: normal;
  font-family: 'Trebuchet MS', 'Helvetica', sans-serif;
  font-weight: bold;
  margin: 0;
}
.text,
.text >>> p {
  font-size: 12px;
  line-height: normal;
  font-family: 'Trebuchet MS', 'Helvetica', sans-serif;
  margin: 0;
}
.date {
  font-size: 11px;
  line-height: normal;
  color: #b7b7b7;
}
</style>



// WEBPACK FOOTER //
// src/common/components/inbox/InboxMessagePreview.vue